export const COLOR_PRESETS = [
  // Core palette: Blue, Yellow, White, Red
  { name: "Blue", color: "#2563EB", text: "#FFFFFF" },
  { name: "Yellow", color: "#FACC15", text: "#0A0B10" },
  { name: "White", color: "#FFFFFF", text: "#0A0B10" },
  { name: "Red", color: "#EF4444", text: "#FFFFFF" },
  // Extended
  { name: "Navy", color: "#1E3A8A", text: "#FACC15" },
  { name: "Deep Blue", color: "#1D4ED8", text: "#FFFFFF" },
  { name: "Gold", color: "#F59E0B", text: "#0A0B10" },
  { name: "Crimson", color: "#9B1C1C", text: "#FFFFFF" },
  { name: "Cream", color: "#FEF3C7", text: "#0A0B10" },
  { name: "Sky", color: "#3B82F6", text: "#FFFFFF" },
  { name: "Ruby", color: "#DC2626", text: "#FFFFFF" },
  { name: "Sun", color: "#FDE047", text: "#0A0B10" },
  { name: "Slate", color: "#1A1C29", text: "#FACC15" },
  { name: "Onyx", color: "#0F172A", text: "#FFFFFF" },
];

export default function ColorPicker({ value, textColor, onChange }) {
  return (
    <div data-testid="color-picker" className="space-y-3">
      <div className="grid grid-cols-7 gap-2">
        {COLOR_PRESETS.map((p) => {
          const active = value === p.color;
          return (
            <button
              key={p.color}
              type="button"
              data-testid={`color-opt-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => onChange({ color: p.color, text_color: p.text })}
              className={`w-10 h-10 rounded-xl flex items-center justify-center border-2 transition ${
                active ? "border-white scale-110" : "border-white/10 hover:scale-105"
              }`}
              style={{ backgroundColor: p.color }}
              title={p.name}
            >
              {active && (
                <span
                  className="w-2 h-2 rounded-full"
                  style={{ backgroundColor: p.text }}
                />
              )}
            </button>
          );
        })}
      </div>

      <div className="flex items-center gap-3 pt-2">
        <label className="text-[10px] font-mono uppercase tracking-[0.15em] text-white/50">
          Custom
        </label>
        <input
          data-testid="color-custom-bg"
          type="color"
          value={value}
          onChange={(e) => onChange({ color: e.target.value, text_color: textColor })}
          className="w-10 h-10 rounded-lg bg-transparent border border-white/10 cursor-pointer"
        />
        <label className="text-[10px] font-mono uppercase tracking-[0.15em] text-white/50">
          Texto
        </label>
        <input
          data-testid="color-custom-text"
          type="color"
          value={textColor}
          onChange={(e) => onChange({ color: value, text_color: e.target.value })}
          className="w-10 h-10 rounded-lg bg-transparent border border-white/10 cursor-pointer"
        />
      </div>
    </div>
  );
}
